"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_validator_1 = require("class-validator");
const Resource_1 = __importDefault(require("../../Resource"));
const class_transformer_1 = require("class-transformer");
const ESubModeEntreeRelation_1 = require("../../../enums/Scpi/PhysicalPerson/AutreCgp/ESubModeEntreeRelation");
const ESubCommentConnuConsultim_1 = require("../../../enums/Scpi/PhysicalPerson/AutreCgp/ESubCommentConnuConsultim");
const EAutreCgpCorporationGroups_1 = require("../../../enums/Scpi/Corporation/Groups/EAutreCgpCorporationGroups");
class GenericAutreCgpRequestResource extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.category = "autre_cgp";
    }
}
exports.default = GenericAutreCgpRequestResource;
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.appreciationClientCorporation] }),
    (0, class_validator_1.IsString)({ groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.appreciationClientCorporation] }),
    (0, class_transformer_1.Expose)({ groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.appreciationClientCorporation] }),
    __metadata("design:type", Object)
], GenericAutreCgpRequestResource.prototype, "appreciationClientCorporation", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.appreciationOperationCorporation] }),
    (0, class_validator_1.IsString)({ groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.appreciationOperationCorporation] }),
    (0, class_transformer_1.Expose)({ groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.appreciationOperationCorporation] }),
    __metadata("design:type", Object)
], GenericAutreCgpRequestResource.prototype, "appreciationOperationCorporation", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(ESubModeEntreeRelation_1.ESubModeEntreeRelation, { groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.modeEntreeRelationCorporation] }),
    (0, class_transformer_1.Expose)({ groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.modeEntreeRelationCorporation] }),
    __metadata("design:type", Object)
], GenericAutreCgpRequestResource.prototype, "modeEntreeRelationCorporation", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(ESubCommentConnuConsultim_1.ESubCommentConnuConsultim, { groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.commentConnuConsultimCorporation] }),
    (0, class_transformer_1.Expose)({ groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.commentConnuConsultimCorporation] }),
    __metadata("design:type", Object)
], GenericAutreCgpRequestResource.prototype, "commentConnuConsultimCorporation", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)({ groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.dateEntreeRelationCorporation] }),
    (0, class_transformer_1.Expose)({ groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.dateEntreeRelationCorporation] }),
    __metadata("design:type", Date)
], GenericAutreCgpRequestResource.prototype, "dateEntreeRelationCorporation", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)({ groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.coherenceSituationPatrimonialeInvestCorporation] }),
    (0, class_transformer_1.Expose)({ groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.coherenceSituationPatrimonialeInvestCorporation] }),
    __metadata("design:type", Boolean)
], GenericAutreCgpRequestResource.prototype, "coherenceSituationPatrimonialeInvestCorporation", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((o) => o.coherenceSituationPatrimonialeInvestCorporation === false, {
        groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.coherenceSituationPatrimonialeInvestCorporation],
    }),
    (0, class_validator_1.IsNotEmpty)({ groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.coherenceSituationPatrimonialeInvestCorporation] }),
    (0, class_validator_1.IsString)({ groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.coherenceSituationPatrimonialeInvestCorporation] }),
    (0, class_transformer_1.Expose)({ groups: [EAutreCgpCorporationGroups_1.EAutreCgpCorporationGroups.coherenceSituationPatrimonialeInvestCorporation] }),
    __metadata("design:type", String)
], GenericAutreCgpRequestResource.prototype, "coherenceSituationPatrimonialeInvestPrecisionCorporation", void 0);
